import React, { useEffect, useState } from "react";
import OmniFormGroup from "../OmniFormGroup/OmniFormGroup";
import Preloader from "../../Preloader";
import DropDownMenu from "../DropDownMenu";

let date = new Date();
date.setMonth(date.getMonth() - 1);

const GridReportWidget = ({
  reportDataGetter,
  reportDownloader,
  reportName,
  filterParams,
  DataGridModule,
  _,
}) => {
  const { Scrolling, Sorting, LoadPanel, DataGrid } = DataGridModule;

  const [dataSource, setDataSource] = useState([]);
  const [showPreloader, setShowPreloader] = useState(false);
  const [params, setparams] = useState({});
  const [options, setOptions] = useState({});
  const [loadPanelEnabled, setLoadPanelEnabled] = useState(true);

  useEffect(() => {
    const _params = {};
    filterParams.map((filter) => (_params[filter.name] = filter.value));
    Object.keys(params)
      .filter((param) => param in _params)
      .map((param) => (_params[param] = params[param]));
    setparams(_params);

    if (
      filterParams &&
      filterParams.length &&
      filterParams.filter((f) => f.source).length > 0
    ) {
      filterParams
        .filter((f) => f.source)
        .map((param) =>
          param.source().then((res) => {
            setOptions({ ...options, [param.name]: res });
          })
        );
    } else {
      getReport(_params);
    }
  }, [reportName]);

  const getReport = (parameters) => {
    setShowPreloader(true);
    reportDataGetter({
      ...parameters,
    })
      .then((res) => {
        setDataSource(res);
        setShowPreloader(false);
      })
      .catch((error) => {
        setDataSource([]);
        setShowPreloader(false);
      });
  };

  const updateParams = (payload) => {
    const newParams = { ...params, ...payload };
    setparams(newParams);
  };
  const updateDateParams = (name, e) => {
    const newParams = { ...params, [name]: e };
    setparams(newParams);
  };

  const onContentReady = () => {
    setLoadPanelEnabled(false);
  };

  return (
    <>
      {dataSource && dataSource.length > 0 && (
        <DropDownMenu
          className="portlet-menu"
          BtnClass="portlet-menu-button"
          Items={[
            {
              Text: "Download",
              attr: {
                onClick: () => {
                  setShowPreloader(true);
                  reportDownloader({
                    ...params,
                  }).then((blob) => {
                    const link = document.createElement("a");
                    link.setAttribute("href", window.URL.createObjectURL(blob));
                    link.setAttribute("download", `${reportName}.csv`);
                    link.click();
                    setShowPreloader(false);
                  });
                },
              },
            },
          ]}
        />
      )}
      <div className="table-widget">
        {showPreloader && <Preloader />}
        {filterParams && filterParams.length > 0 && (
          <div className="container table-widget-form">
            <div className="row">
              {filterParams.map((filter, index) => (
                <div key={index} className="col-4">
                  <OmniFormGroup
                    Id={filter.name}
                    Name={filter.name}
                    Type={filter.type}
                    Placeholder={filter.text}
                    LabelName={filter.text}
                    value={params[filter.name]}
                    onChange={(e) => {
                      if (filter.type === "date") {
                        updateDateParams(filter.name, e);
                      }

                      if (filter.type === "select") {
                        if (filter.name === "custTypes") {
                          if (e.target.value >= 0) {
                            const selected =
                              options[filter.name][e.target.value];
                            const payload = {
                              itemType: selected.typeGroupId,
                              referenceField: selected.fieldName.replace(
                                "Caption",
                                ""
                              ),
                            };
                            updateParams(payload);
                          }
                        } else if (filter.name === "rateCardYears") {
                          if (e.target.value >= 0) {
                            const selected =
                              options[filter.name][e.target.value];
                            const payload = {
                              referenceField: selected.fieldValue,
                            };
                            updateParams(payload);
                          }
                        }
                      }
                    }}
                  >
                    {options[filter.name] && (
                      <>
                        <option value="-1">{_.Choose}</option>
                        {options[filter.name].map((item, key) => (
                          <option key={key} value={key}>
                            {item.category} - {item.fieldValue}
                          </option>
                        ))}
                      </>
                    )}
                  </OmniFormGroup>
                </div>
              ))}
              <div className="col-4 report-search">
                <i
                  className="icon-omni-search"
                  onClick={() => getReport(params)}
                ></i>
              </div>
            </div>
          </div>
        )}

        <div className="container-fluid ml-3 table-widget-small">
          {dataSource && dataSource.length ? (
            <div className="table-container">
              <DataGrid
                id="reportGridContainer"
                allowColumnResizing={true}
                allowColumnReordering={true}
                columnAutoWidth={true}
                dataSource={dataSource}
                showBorders={true}
                onContentReady={onContentReady}
                height="calc(100vh - 410px)"
              >
                <Sorting mode="multiple" />

                <Scrolling mode="virtual" />
                <LoadPanel enabled={loadPanelEnabled} />
              </DataGrid>
            </div>
          ) : (
            !showPreloader && (
              <div className="table-container">
                <div className="no-data">{_.NoResultsForSelection};</div>
              </div>
            )
          )}
        </div>
      </div>
    </>
  );
};
export default GridReportWidget;
